import { render, staticRenderFns } from "./TimUiMedia.vue?vue&type=template&id=b42fbd90&scoped=true&"
import script from "./TimUiMedia.vue?vue&type=script&lang=js&"
export * from "./TimUiMedia.vue?vue&type=script&lang=js&"
import style0 from "./TimUiMedia.vue?vue&type=style&index=0&id=b42fbd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42fbd90",
  null
  
)

export default component.exports